// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"Switch_pattern-gradient__gX-0q","container":"Switch_container__fEEKR","thumb":"Switch_thumb__Pk0bJ","active":"Switch_active__4us+s"};